import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { ui } from '@wp-g2/styles';
import React from 'react';
import { View } from '../View';
import { VisuallyHidden } from '../VisuallyHidden';

function SelectDropdownLabel(props) {
  var hideLabelFromVision = props.hideLabelFromVision,
      otherProps = _objectWithoutProperties(props, ["hideLabelFromVision"]);

  var Component = hideLabelFromVision ? VisuallyHidden : View;
  return /*#__PURE__*/React.createElement(Component, Object.assign({}, otherProps, ui.$('SelectDropdownLabel')));
}

export default SelectDropdownLabel;